module.exports = __webpack_public_path__ + "img/hombre.09a9c478.svg";